export default __webpack_public_path__ + "static/media/trash.6b7f0b27.mp3";